export const UserListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
	{
		query: 'business_unit_ids',
		transformFn: (v) => {
			if (!v) return [];

			if (Array.isArray(v)) {
				return v.map((id) => String(id).trim()).filter(Boolean);
			}

			// Handle comma-separated string from URL
			if (typeof v === 'string' && v.includes(',')) {
				return v
					.split(',')
					.map((id) => id.trim())
					.filter(Boolean);
			}

			const normalizedId = String(v).trim();
			return normalizedId ? [normalizedId] : [];
		},
		value: [],
	},
];

export const ApprovalListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
];

export const VendorListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
	{
		query: 'business_unit_ids',
		transformFn: (v) => {
			if (!v) return [];

			if (Array.isArray(v)) {
				return v.map((id) => String(id).trim()).filter(Boolean);
			}

			// Handle comma-separated string from URL
			if (typeof v === 'string' && v.includes(',')) {
				return v
					.split(',')
					.map((id) => id.trim())
					.filter(Boolean);
			}

			const normalizedId = String(v).trim();
			return normalizedId ? [normalizedId] : [];
		},
		value: [],
	},
];

export const ClientListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
	{
		query: 'business_unit_ids',
		transformFn: (v) => {
			if (!v) return [];

			if (Array.isArray(v)) {
				return v.map((id) => String(id).trim()).filter(Boolean);
			}

			// Handle comma-separated string from URL
			if (typeof v === 'string' && v.includes(',')) {
				return v
					.split(',')
					.map((id) => id.trim())
					.filter(Boolean);
			}

			const normalizedId = String(v).trim();
			return normalizedId ? [normalizedId] : [];
		},
		value: [],
	},
];

export const TemperatureListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
	{
		query: 'business_unit_ids',
		transformFn: (v) => {
			if (!v) return [];

			if (Array.isArray(v)) {
				return v.map((id) => String(id).trim()).filter(Boolean);
			}

			// Handle comma-separated string from URL
			if (typeof v === 'string' && v.includes(',')) {
				return v
					.split(',')
					.map((id) => id.trim())
					.filter(Boolean);
			}

			const normalizedId = String(v).trim();
			return normalizedId ? [normalizedId] : [];
		},
		value: [],
	},
];
export const VehicleListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
];
export const DriverListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
	{
		query: 'business_unit_ids',
		transformFn: (v) => {
			if (!v) return [];

			if (Array.isArray(v)) {
				return v.map((id) => String(id).trim()).filter(Boolean);
			}

			// Handle comma-separated string from URL
			if (typeof v === 'string' && v.includes(',')) {
				return v
					.split(',')
					.map((id) => id.trim())
					.filter(Boolean);
			}

			const normalizedId = String(v).trim();
			return normalizedId ? [normalizedId] : [];
		},
		value: [],
	},
];

export const TripListQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
];

export const ProjectQueries = [
	{
		query: 'query_str',
		transformFn: (v) => v,
		value: '',
	},
];
